// removed by extract-text-webpack-plugin
module.exports = {"SliderPointerDragFix":"CandidateNotice-SliderPointerDragFix","DarkNavLink":"CandidateNotice-DarkNavLink","BodyLink":"CandidateNotice-BodyLink","Container":"CandidateNotice-Container","ArticleWrapper":"CandidateNotice-ArticleWrapper","Article":"CandidateNotice-Article","Pagination":"CandidateNotice-Pagination","PaginationClose":"CandidateNotice-PaginationClose","CloseLink":"CandidateNotice-CloseLink"};


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/theme/Careers/components/CandidateNotice.less
// module id = 113
// module chunks = 0